import Star from '../assets/star.svg?react'

interface IStarRatingProps {
  rating: number
  size?: number
}

export const StarRating = (props: IStarRatingProps) => {
  const { rating, size = 24 } = props
  const maxStars = 5
  const clampedRating = Math.min(Math.max(rating, 0), maxStars)
  const filledStars = Math.round(clampedRating)

  return (
    <div className={'flex gap-1'}>
      {Array.from({ length: maxStars }).map((_, index) => (
        <Star
          key={index}
          width={size}
          height={size}
          className={index < filledStars ? 'fill-yellow-400' : 'fill-gray-300'}
        />
      ))}
    </div>
  )
}
